import React, {useRef} from 'react';
import cn from 'classnames';
import IMG from "../../../constants/image";

const Textarea = ({
                      name,
                      warningIcon,
                      viewOnly,
                      error,
                      title,
                      autoComplete,
                      className,
                      icon,
                      iconR,
                      placeholder,
                      value,
                      onChange,
                      required
                  }) => {

    const inputRef = useRef(null);

    if (viewOnly) {
        return (
            <div className='text-sm w-full'>
                {title && (
                    <div className='flex items-center gap-1'>
                        <p className='mb-1'>{title}</p>
                        {warningIcon && <img className='w-4 h-4' src={warningIcon} alt="warning"/>}
                    </div>

                )}
                <p className='text-[#9E9E9E] py-2'>{value}</p>
            </div>
        );
    }


    return (
        <div className='text-sm w-full'>
            {title &&
                <p className='text-sm mb-1 flex items-center gap-1'>
                    {title}
                    {required && <span className='text-[#E4626F]'>*</span>}
                    {warningIcon && <img className='w-4 h-4' src={warningIcon} alt="warning"/>}
                </p>
            }
            <div
                className={cn('relative flex justify-between items-center p-2 border rounded-lg gap-1', className, error && 'border-red-500 text-[#E4626F]')}>
                {icon && <img className='w-5 h-5' src={icon} alt="icon"/>}
                <textarea
                    ref={inputRef}
                    className='w-full resize-none'
                    name={name}
                    autoComplete={autoComplete || ''}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
                {iconR && <img className='w-4 h-4' src={iconR} alt="iconR"/>}
            </div>
            {error && (
                <div className='flex items-center gap-1 mt-1'>
                    <img src={IMG.icon.errorOutline} alt="errorOutline"/>
                    <p className='text-[#E4626F] text-xs'>{error}</p>
                </div>
            )}
        </div>
    );
};

export default Textarea;